"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
var _Icon2 = require("../../../Icon");
var _Icon3 = _interopRequireDefault(_Icon2);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
var IconTaxiWaveBusinessman = /*#__PURE__*/
function (_Icon) {
  _inherits(IconTaxiWaveBusinessman, _Icon);
  function IconTaxiWaveBusinessman(props) {
    var _this;
    _classCallCheck(this, IconTaxiWaveBusinessman);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(IconTaxiWaveBusinessman).call(this, props));
    _this.name = 'IconTaxiWaveBusinessman';
    _this.icon = _react2.default.createElement("svg", {
      viewBox: "0 0 24 24",
      width: "1em",
      height: "1em",
      focusable: "false",
      "aria-hidden": "true",
      role: "presentation"
    }, _react2.default.createElement("g", {
      className: "taxi-wave-businessman_svg__group0"
    }, _react2.default.createElement("path", {
      className: "taxi-wave-businessman_svg__path0",
      d: "M11.75 6c-1.654 0-3-1.346-3-3s1.346-3 3-3 3 1.346 3 3-1.346 3-3 3zm0-5c-1.103 0-2 .897-2 2s.897 2 2 2 2-.897 2-2-.898-2-2-2z"
    }), _react2.default.createElement("path", {
      className: "taxi-wave-businessman_svg__path1",
      d: "M13.25 24c-.827 0-1.5-.673-1.5-1.5v-4c0-.827.673-1.5 1.5-1.5h1.5c0-.575.254-1.123.682-1.5a2.01 2.01 0 01-.681-1.501v-3a.5.5 0 011 0v3a.999.999 0 001.023 1.002 1 1 0 00.976-.999V10.5c0-1.379-1.122-2.5-2.5-2.5h-5.074a1.49 1.49 0 01-1.178-.573L5.036 2.382a.998.998 0 00-1.789.47.996.996 0 00.197.74l6.203 8.04a.504.504 0 01.104.305V22c0 .552.449 1 1 1a.5.5 0 010 1c-1.103 0-2-.897-2-2v-9.893L2.649 4.198a1.983 1.983 0 01-.393-1.478c.071-.529.343-1 .768-1.324a1.98 1.98 0 011.479-.394c.529.071 1 .343 1.324.768l3.957 5.04c.095.12.238.19.393.19h5.074c1.93 0 3.5 1.57 3.5 3.5V14a1.99 1.99 0 01-.679 1.502c.429.376.677.915.677 1.498h1.5c.827 0 1.5.673 1.5 1.5v4c0 .827-.673 1.5-1.5 1.5H13.25zm0-6a.5.5 0 00-.5.5v4a.5.5 0 00.5.5h7a.5.5 0 00.5-.5v-4a.5.5 0 00-.5-.5h-7zm4.5-1c0-.547-.446-.995-.993-.999h-.014a1.002 1.002 0 00-.993.999h2z"
    })));
    return _this;
  }
  return IconTaxiWaveBusinessman;
}(_Icon3.default);
exports.default = IconTaxiWaveBusinessman;